import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.showTab(0)
  }

  select(event) {
    const index = this.tabTargets.indexOf(event.currentTarget)
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("text-purple-700", "border-purple-700")
        tab.classList.remove("text-gray-500", "border-transparent", "hover:text-gray-700", "hover:border-gray-300")
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.classList.remove("text-purple-700", "border-purple-700")
        tab.classList.add("text-gray-500", "border-transparent", "hover:text-gray-700", "hover:border-gray-300")
        tab.setAttribute("aria-selected", "false")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }

  print() {
    window.print()
  }
}
